import { getOrderStateColor, getOrderStateTranslationKey } from "@msuite/utils/stock";
import type { Enums } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface OrderStateTagProps {
	state: Enums<"orderState">;
	size?: TagProps["size"];
}

export function OrderStateTag({ state, size }: OrderStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			variant="plain"
			withPing={["picking", "in-progress"].includes(state)}
			color={getOrderStateColor(state)}
			className="-mx-2 px-2"
			size={size}
		>
			{t(getOrderStateTranslationKey(state))}
		</Tag>
	);
}
